import React from 'react';
import Text from './base';

const Body = props => <Text defaultTag="div" variant="body" {...props} />;

export default Body;
